import axios from 'axios';

const api = axios.create({
   baseURL: 'http://inforfolha.com.br:3335', // servidor
 // baseURL: 'http://localhost:3335', // local  
});

export default api;
